import React from 'react'
import { Col, Card, CardBody, Media } from 'reactstrap'

export default props => (
  <Col md={4}>
    <Card>
      <CardBody>
        <Media>
          <Media body className="overflow-hidden">
            <p className="text-truncate font-size-14 mb-2">Banco de horas</p>
            <h4 className="mb-0">{props.value}</h4>
          </Media>
        </Media>
      </CardBody>
      <CardBody className="border-top py-3">
        <div className="text-truncate">
          <span className="badge badge-soft font-size-11 mr-1">
            {props.variation}
          </span>
          <span className="text-muted ml-1" title="em relação ao mês anterior">
            em relação ao mês anterior
          </span>
        </div>
      </CardBody>
    </Card>
  </Col>
)
